import React from 'react';
import { Loader2 } from 'lucide-react';

interface PullToRefreshIndicatorProps {
  isPulling: boolean;
  isRefreshing: boolean;
  pullProgress: number;
}

const PullToRefreshIndicator: React.FC<PullToRefreshIndicatorProps> = ({
  isPulling,
  isRefreshing,
  pullProgress
}) => {
  if (!isPulling && !isRefreshing) return null;

  const opacity = Math.min(pullProgress, 1);
  const scale = 0.5 + Math.min(pullProgress, 1) * 0.5;
  const translateY = Math.min(pullProgress * 40, 50);

  return (
    <div 
      className="absolute left-0 right-0 flex justify-center pointer-events-none z-10"
      style={{ 
        top: 0,
        transform: `translateY(${translateY}px)`,
        opacity: isRefreshing ? 1 : opacity,
        transition: isRefreshing ? 'none' : 'transform 0.1s ease-out'
      }}
    >
      <div 
        className="w-8 h-8 rounded-full bg-background shadow-lg flex items-center justify-center"
        style={{ 
          transform: `scale(${isRefreshing ? 1 : scale})`,
          transition: isRefreshing ? 'none' : 'transform 0.1s ease-out'
        }}
      >
        <Loader2 
          className={`w-5 h-5 text-primary ${isRefreshing ? 'animate-spin' : ''}`}
          style={{ 
            transform: isRefreshing ? 'none' : `rotate(${pullProgress * 360}deg)`,
            transition: 'none'
          }}
        />
      </div>
    </div>
  );
};

export default PullToRefreshIndicator;
